Pixlee.module('WidgetsApp', function(WidgetsApp, App, Backbone, Marionette, $) {
    var _this = this,
        API;
    WidgetsApp.Router = Marionette.AppRouter.extend({
        appRoutes: {
            "photowall": "photowall",
            "photowall/:id": "photowallItem",
            "horizontal": "horizontal",
            "horizontal/:id": "horizontalItem"
        }
    });

    var socket;
    API = {
        widgetLoaded: function(time, photos) {
            /*if (typeof performance != 'undefined' && typeof performance.now != 'undefined' && typeof console != 'undefined') {
                console.log(performance.now());
            }*/
            var userId;
            var _this = this;
            if (typeof analytics !== 'undefined' && analytics.getAnonymousId) {
                userId = analytics.getAnonymousId();
            }

            if (!_this.KeenClient && typeof Keen != 'undefined') {
                Keen.ready(function() {
                    _this.KeenClient = new Keen({
                        projectId: keen_project_id,
                        writeKey: keen_write_key,
                        host: gon.global.env.startsWith('staging') ? 'tinyrick.stag.pixlee.io' : 'tinyrick.pixlee.com'
                    });
                    _this.logger.openWidget(gon.widget, time, photos);
                });
            }

            this.postMessage({
                msg: 'setCookie',
                user: userId,
                fingerprint: gon.fingerprint
            });

        },
        getCookie: function(cname) {
            return this._getCookieHelper(cname) || this._getCookieHelper(cname + '_legacy');
        },

        _getCookieHelper: function(cname) {
          var name = cname + "=";
          var ca = document.cookie.split(';');
          for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        },
        addKeenData: function(obj) {
            var addons = [];

            addons.push({
                name: 'keen:ip_to_geo',
                input: {
                    ip: 'ip_address'
                },
                output: 'ip_geo_info'
            });
            obj.ip_address = gon.remote_ip;

            addons.push({
                name: 'keen:ua_parser',
                input: {
                    ua_string: 'user_agent'
                },
                output: 'parsed_user_agent'
            });
            obj.user_agent = navigator.userAgent;

            addons.push({
                name: 'keen:url_parser',
                input: {
                    url: 'page_url'
                },
                output: 'parsed_page_url'
            });
            obj.page_url = document.location.href;

            addons.push({
                name: 'keen:referrer_parser',
                input: {
                    referrer_url: 'referrer_url',
                    page_url: 'page_url'
                },
                output: 'referrer_info'
            });
            obj.referrer_url = document.referrer;
            obj.page_url = document.location.href;

            obj.keen = {
                addons: addons
            };
        },
        trackAnalytics: function(ev, props) {
            if (this.KeenClient) {
                if (gon.region_id) {
                    props.region_id = gon.region_id;
                }
                this.addKeenData(props);
                this.KeenClient.recordEvent(ev, props);
            }
        },
        photowall: function() {
            var _this = this;
            _this.beginInterval();
            this.photoWallController = new WidgetsApp.Photowall.Controller({
                type: 'photowall'
            });
        },
        photowallItem: function(photo, album) {
            this.itemController(photo, album);
        },
        itemController: function(photo, album) {
            var _this = this;
            this.itemControl = this.routeToItem({
                photo: photo,
                album: album
            });
            this.itemControl.on({
                'change:photo': _this.itemControl.changePhoto,
                'is:video': _this.itemControl.isVideo
            });
        },
        routeToItem: function(options) {
            return new WidgetsApp.Item.Controller(options);
        },
        changeUrl: function(id) {
            if (gon.editCssEvents) return false;
            if (id) {
                this.postMessage({
                    msg: 'changeUrl',
                    url: this.insertParam(this.url, 'pixlee_album_photo_id', id)
                });
            } else {
                this.logger.leaveLightbox(gon.widget);
                this.postMessage({
                    msg: 'changeUrl',
                    url: this.removeParam(this.url, 'pixlee_album_photo_id')
                });
            }
        },
        openItem: function(photoModel) {
            var _this = this;
            this.itemControl = this.routeToItem({
                photoModel: photoModel
            });
            this.itemControl.on({
                'change:photo': _this.itemControl.changePhoto,
                'is:video': _this.itemControl.isVideo
            });
        },
        triggerChangePhoto: function(wrapper, photo) {
            this.checkViewedPhoto(photo);
            this.logger.openPhoto(gon.widget, photo);
            this.postMessage({
                msg: 'photoOpen',
                album_photo_id: photo
            });
            this.changeUrl(photo);
            this.itemControl.trigger('change:photo', wrapper, photo);
        },
        checkViewedPhoto: function(photo) {
            if (!gon.viewingPhoto) {
                if (photo) {
                    gon.viewingPhoto = photo;
                    gon.startViewPhoto = this.logger.getTime();
                }
            } else if (gon.startViewPhoto) {
                if (photo) {
                    gon.startViewPhoto = this.logger.getTime();
                    gon.viewingPhoto = photo;
                } else {
                    gon.viewingPhoto = null;
                    gon.startViewPhoto = null;
                }

            }
        },
        isVideo: function(container, video, selectedArray, selectedIndex) {
            this.itemControl.trigger('is:video', container, video, selectedArray, selectedIndex);
        },
        horizontal: function() {
            var _this = this;
            _this.beginInterval();
            this.photoWallController = new WidgetsApp.Photowall.Controller({
                type: 'horizontal'
            });
        },
        loadMoreLightBox: function() {
            if (gon.widget == 'horizontal') {
                this.photoWallController.collectionView.trigger('load:more:horizontal');
            } else {
                this.photoWallController.photowallLayout.trigger('load:more:clicked');
            }
        },
        horizontalItem: function(photo, album) {
            this.itemController(photo, album);
        },
        itemOpen: function() {
            if (!this.lightBoxOpen) {
                if (gon.widget === 'photowall' && !gon.packery && !gon.v2) $('#container').masonry('unbindResize');
                if (gon.packery) $('#container').packery('unbindResize');
                this.lightBoxOpen = true;
                this.postMessage({
                    msg: 'viewPhoto'
                });
                $('#lightBox-wrapper').show();
                this.hideWall();
            }
        },
        initInfiniteScroll: function() {
            this.postMessage({
                msg: 'initScroll'
            });
        },
        checkWindow: function() {
            this.postMessage({
                msg: 'checkWindow'
            });
        },
        initSocket: function(msg) {
            var _this = this;
            this.socket = new easyXDM.Socket({
                onReady: function() {
                    gon.current_user = gon.current_account;
                    _this.postMessage({
                        msg: msg,
                        mobile: gon.isMobileDevice
                    });
                    $('#basic_upload_link, #upload_button').click(function() {
                        if (gon.editCssEvents) return false;
                        _this.goToUpload($(this));
                        return false;
                    });
                },
                onMessage: function(msg) {
                    var obj;
                    try {
                        obj = JSON.parse(msg);
                    } catch (e) {
                        console.log(e);
                    }
                    if (obj.editCss) {
                        if (obj.openLightBoxCssGen) {
                            if (gon.widget == 'horizontal') {
                                _this.loadPhoto(Routes.backbone.horizontal_path, 30659140);
                            } else {
                                _this.loadPhoto(Routes.backbone.photowall_path, 30659140);
                            }
                            $('#fancybox-close, #fancybox-overlay').remove();
                            return false;
                        }
                        if (obj.openUploaderCssGen) {
                            _this.goToUpload($('#upload_button'));
                            return false;
                        }
                        if (obj.closeLightBox && $.fancybox) {
                            $.fancybox.close();
                            if (gon.widget == 'horizontal') {
                                // App.navigate(Routes.backbone.horizontal_path, {trigger: true});
                            }
                        }
                        if (obj.editCssEvents) {
                            gon.editCssEvents = true;
                            return false;
                        }
                        if (obj.editRendering) {
                            $(obj.elem).css(obj.prop, obj.val);
                            if (gon.widget == 'horizontal') {
                                _this.photoWallController.collectionView.sly.reload();
                                _this.photoWallController.collectionView.calcHorizontal();
                            }
                        }
                        if (obj.reRender) {
                            if (gon.display_options) {
                                gon.display_options[obj.display_option] = obj.option;
                            }

                            return false;
                        }
                        if (obj.display_option) {
                            if (obj.attr) {
                                $(obj.elem).attr(obj.attr, obj.text);
                            } else if (obj.text) {
                                if (obj.display_option == 'pageSize') {
                                    App.displayOptions.set('pageSize', parseInt(obj.text, 10));
                                } else if (obj.display_option == 'showVoteCount') {
                                    App.displayOptions.set('showVoteCount', obj.text);
                                } else {
                                    $(obj.elem).text(obj.text);
                                }
                            }

                            gon.display_options[obj.display_option] = obj.text;
                        } else {
                            var addCSSRule = function(sheet, selector, rules, index) {
                                if (sheet.insertRule) {
                                    sheet.insertRule(selector + "{" + rules + "}", 0);
                                } else {
                                    //<ie9
                                    sheet.addRule(selector, rules, 0);
                                }
                            };

                            gon.sheet = (function() {
                                var style = document.createElement("style");
                                style.appendChild(document.createTextNode(""));
                                style.id = "custom-stylesheet";
                                document.head.appendChild(style);

                                return style.sheet;
                            })();
                            if (obj.initSheet) {
                                document.getElementById('custom-stylesheet').innerHTML = obj.sheet;
                                return false;
                            }
                            if (obj.custom) {
                                document.getElementById('custom-stylesheet').innerHTML = obj.val;
                                return false;
                            } else if (obj.addFont) {
                                var head = document.getElementsByTagName('head')[0];
                                var link = document.createElement('link');
                                link.rel = 'stylesheet';
                                link.type = 'text/css';
                                link.href = obj.val;
                                link.media = 'all';
                                head.appendChild(link);
                                return false;
                            } else {
                                addCSSRule(gon.sheet, obj.elem, obj.prop + ': ' + obj.val);
                            }


                        }



                        return false;
                    }
                    if (obj.FB_APP_ID) {
                        gon.FB_APP_ID = obj.FB_APP_ID
                    }
                    if (obj.scrolledToBottom && !gon.isMobileDevice && !_this.loading && !_this.lightBoxOpen) {
                        App.commands.execute("scrolled:to:bottom");
                        return false;
                    }
                    if (obj.resizeForMobile && gon.isMobileDevice) {
                        gon.winWidth = obj.winWidth;
                        gon.winHeight = obj.winHeight;
                        return false;
                    }
                    if (obj.resizeEvent && gon.isMobileDevice && _this.swipebox) {
                        gon.winWidth = obj.winWidth;
                        gon.winHeight = obj.winHeight;
                        setTimeout(function() {
                            _this.swipebox.orientationchange();
                        }, 500);
                        return false;
                    }
                    if (obj.resizeMobile && gon.isMobileDevice && gon.widget === 'horizontal') {
                        gon.winWidth = obj.winWidth;
                        gon.winHeight = obj.winHeight;
                        setTimeout(function() {
                            $('#photos_region').css('width', obj.containerWidth);
                        }, 200);
                        return false;
                    }
                    if (gon.isMobileDevice) {
                        gon.winWidth = obj.winWidth;
                        gon.winHeight = obj.winHeight;
                        $('body').addClass('is-mobile-device');
                        gon.containerWidth = obj.containerWidth;
                    }
                    if (obj.debug) {
                        _this.testActions[obj.fn](obj.args);
                        return false;
                    }
                    if (obj.infiniteScroll && !gon.isMobileDevice) {
                        gon.infiniteScroll = true;
                    }
                    if (obj.url) {
                        if (obj.packery) {
                            gon.packery = true;
                        }
                        gon.widgetDisplay = obj.display;
                        if (location.pathname.substr(location.pathname.lastIndexOf('/') + 1) == 'v2') {
                            gon.v2 = true;
                        }

                        _this.url = obj.url;
                        gon.parentURL = obj.url;
                        if (obj.meta_tags) {
                            gon.meta_tags = obj.meta_tags;
                        }
                        if (obj.title) {
                            gon.parent_title = obj.title;
                        }
                        gon.availWidth = obj.availWidth;
                        gon.availHeight = obj.availHeight;
                        gon.offsetY = obj.offsetY;
                        gon.docHeight = obj.docHeight;

                        if (obj.embed) {
                            gon.widgetInitTime = _this.logger.getTime();
                            gon.widget = 'photowall';
                            if (obj.pixlee_album_photo_id) {
                                _this.loadPhoto(Routes.backbone.photowall_path, obj.pixlee_album_photo_id);
                            } else {
                                App.navigate(Routes.backbone.photowall_path, {
                                    trigger: true
                                });
                            }
                        } else if (obj.horizontal) {
                            gon.widgetInitTime = _this.logger.getTime();
                            gon.widget = 'horizontal';
                            gon.containerWidth = obj.containerWidth;
                            if (obj.pixlee_album_photo_id) {
                                _this.loadPhoto(Routes.backbone.horizontal_path, obj.pixlee_album_photo_id);
                            } else {
                                App.navigate(Routes.backbone.horizontal_path, {
                                    trigger: true
                                });
                            }
                        }
                    }


                }
            });
            socket = this.socket;
        },
        goToUpload: function(elem) {
            this.postMessage({
                msg: 'goToUpload',
                src: elem.attr('href')
            });
        },
        loadPhoto: function(widget, id) {
            var _this = this;
            if (!_this.KeenClient && typeof Keen != 'undefined') {
                Keen.ready(function() {
                    _this.KeenClient = new Keen({
                        projectId: keen_project_id,
                        writeKey: keen_write_key,
                        host: gon.global.env.startsWith('staging') ? 'tinyrick.stag.pixlee.io' : 'tinyrick.pixlee.com'
                    });
                });
            }
            Pixlee.commands.execute('resize:window');
            _this.getPhoto(id, function(photo) {
                _this.openFancyBox(widget, photo);
                _this.openItem(photo);
            });
        },
        getPhoto: function(id, callback) {
            let photo = new App.Entities.Photo();
            photo.attributes.album_photo_id = parseInt(id, 10);
            photo.fetch({
                success: function(model) {
                    callback(model);
                }
            });
        },
        postMessage: function(msg) {
            var obj = JSON.stringify(msg);
            this.socket.postMessage(obj);
        },
        beginInterval: function() {
            var _this = this;
            var t = function() {
                setTimeout(function() {
                    if (!_this.lightBoxOpen) {
                        _this.postMessage({
                            msg: 'render',
                            height: $('body').height()
                        });
                    }
                    t();
                }, 100);
            };
            t();
        },
        openFancyBox: function(widget, model) {
            var _this = this;
            var opts;
            if (gon.isMobileDevice) {
                opts = {
                    useCSS: true, // false will force the use of jQuery for animations
                    hideBarsDelay: 0, // 0 to always show caption and action bar
                    videoMaxWidth: 1140, // videos max width
                    App: App,
                    model: model,
                    beforeOpen: function() {
                        Pixlee.commands.execute('resize:window');
                    },
                    afterClose: function() {
                        _this.showWall();
                        _this.lightBoxOpen = false;
                        _this.postMessage({
                            msg: 'closePhoto'
                        });
                        $('#lightBox-wrapper').hide();
                        App.navigate(widget, {
                            trigger: true
                        });
                        _this.changeUrl();
                    }
                };
            } else {
                opts = {
                    padding: 0,
                    container: true,
                    imageContainerWidth: 320,
                    imageContainerHeight: 620,
                    overlayOpacity: 0,
                    lightBoxContainer: '#lightBox',
                    App: App,
                    model: model,
                    selectedPhoto: model.get('album_photo_id'),
                    onClosed: function() {
                        _this.lightBoxOpen = false;
                        _this.postMessage({
                            msg: 'closePhoto'
                        });
                        _this.showWall();
                        $('#lightBox-wrapper').hide();
                        App.navigate(widget, {
                            trigger: true
                        });
                        _this.changeUrl();
                        // _this.showOrHideWall(1);
                    }
                };
            }

            var href;
            if (model.get('content_type') === 'video') {
                // If there is a custom thumbnail in video settings, return it as the thumbnail
                var videoThumbnail = model.getCustomVideoThumbnail();
                href = videoThumbnail ? videoThumbnail : model.get('thumbnail_url');
            } else {
                if (model.get('source_url')) {
                    href = model.get('source_url');
                } else if (model.get('data_file_name')) {
                    var bucket = 'pixlee-prod';
                    if (gon.global.env == 'development') {
                        bucket = 'pixlee-dev';
                        href = 'http://s3.amazonaws.com/' + bucket + '/photos/' + model.id + '/' + 'xl' + '/' + model.get('data_file_name');
                    }
                    href = 'https://static.pxlecdn.com/photos/' + model.id + '/' + 'xl' + '/' + model.get('data_file_name');
                }
            }
            if (gon.isMobileDevice) {
                $.swipebox([{
                    href: href
                }], opts);
            } else {
                $.fancybox({
                    href: href
                }, opts);
            }
            //tall image test
            //$.fancybox({href: 'http://wvs.topleftpixel.com/photos/scotia_plaza_tall_stitched.jpg'}, opts);
            //wide image test
            //$.fancybox({href: 'http://upload.wikimedia.org/wikipedia/commons/e/e5/Seine_wide.jpg'}, opts);
            //big image test
            //$.fancybox({href: 'http://upload.wikimedia.org/wikipedia/commons/e/e0/Clouds_over_the_Atlantic_Ocean.jpg'}, opts);
            //small image test
            //$.fancybox({href: 'https://g.twimg.com/business/page/image/11TwitterForSmallBusiness-300_1.png'}, opts);
        },
        initFancyBox: function(collection) {
            var _this = this;
            if (gon.editCssEvents) return false;
            if (gon.isMobileDevice) {
                this.swipebox = $(App.widgetsRegion.el).find('.lightboxed').swipebox({
                    useCSS: true, // false will force the use of jQuery for animations
                    hideBarsDelay: 0, // 0 to always show caption and action bar
                    videoMaxWidth: 1140, // videos max width
                    App: App,
                    $selectedElem: '.lightboxed',
                    collection: collection,
                    beforeOpen: function() {
                        Pixlee.commands.execute('resize:window');
                    },
                    afterClose: function() {
                        _this.showWall();
                        _this.lightBoxOpen = false;
                        _this.postMessage({
                            msg: 'closePhoto'
                        });

                        $('#lightBox-wrapper').hide();
                        _this.changeUrl();
                    }
                });
            } else {
                var opts = {
                    padding: 0,
                    container: true,
                    imageContainerWidth: 320,
                    imageContainerHeight: 620,
                    overlayOpacity: 0,
                    lightBoxContainer: '#lightBox',
                    App: App,
                    collection: collection,
                    onClosed: function() {
                        _this.showWall();
                        _this.lightBoxOpen = false;
                        _this.postMessage({
                            msg: 'closePhoto'
                        });

                        $('#lightBox-wrapper').hide();
                        if (gon.widget === 'photowall' && !gon.packery && !gon.v2) $('#container').masonry('bindResize');
                        if (gon.packery) $('#container').packery('bindResize');
                        _this.changeUrl();
                        // _this.showOrHideWall(1);
                    }
                };
                $(App.widgetsRegion.el).find('.lightboxed').not('.inactivated').fancybox(opts);
            }

        },
        voteClicked: function(view, model) {
            var _this = this;
            var fingerprint = gon.fingerprint;
            if (typeof analytics !== 'undefined' && analytics.getAnonymousId) {
                var segmentId = analytics.getAnonymousId();
            }
            var popUpUrl = '/cookie?f=' + fingerprint;

            function popupwindow(url, title, w, h) {
                var left = (screen.width / 2) - (w / 2);
                var top = (screen.height / 2) - (h / 2);
                return window.open(url, title, 'toolbar=no,titlebar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
            }
            popupwindow(popUpUrl, 'Thank You!', 493, 194);
            if (gon.editCssEvents) {
                model.attributes.userVoted = true;
                model.trigger('voted');
                return false;
            }
            $.ajax({
                url: '/social/like',
                type: 'POST',
                data: {
                    id: model.get('album_photo_id'),
                    distinct_user_hash: gon.distinct_user_hash,
                    fingerprint: gon.fingerprint
                },
                dataType: 'json',
                success: function(response) {
                    if (response.error_code == 0) {
                        //vote successfull
                        model.attributes.like_count = response.like_count;
                        model.attributes.userVoted = true;

                        model.trigger('voted');
                    }
                    /* else if (response.error_code == 1) {
                    						//album
                    						//console.log("album_photo dosn't exist");
                    					}
                    					else if (response.error_code == 2) {
                    						//console.log("couldn't save the like something went wrong retry");
                    					}*/
                    else if (response.error_code == 3) {
                        //console.log("This user already voted");
                        //The cookies must have been deleted reset them
                        model.attributes.userVoted = true;
                        model.trigger('voted');
                    }
                }
            });
        },
        showWall: function() {
            $('#photos_container').removeClass('lightbox-is-active');
            $('#widget_header_table, #photowall_description').show();
            $('.upload_instruction_table').show();
            $('#container').css('opacity', '1');
            $('#load_more, #no_more_photos').css('opacity', '1');
            if (gon.widget === 'horizontal') $('#photowall_footer_region').show();
            gon.lightBoxOpen = false;
            this.checkViewedPhoto();
        },
        hideWall: function() {
            $('#photos_container').addClass('lightbox-is-active');
            $('#widget_header_table, #photowall_description').hide();
            $('.upload_instruction_table').hide();
            $('#container').css('opacity', '0');
            $('#load_more, #no_more_photos').css('opacity', '0');
            gon.lightBoxOpen = true;
            if (gon.widget === 'horizontal') $('#photowall_footer_region').hide();
        },
        insertParam: function(url, paramName, paramValue) {
            if (url.indexOf(paramName + '=') >= 0) {
                var prefix = url.substring(0, url.indexOf(paramName));
                var suffix = url.substring(url.indexOf(paramName)).substring(url.indexOf('=') + 1);
                suffix = (suffix.indexOf('&') >= 0) ? suffix.substring(suffix.indexOf('&')) : '';
                url = prefix + paramName + '=' + paramValue + suffix;
            } else {
                if (url.indexOf('?') < 0)
                    url += '?' + paramName + '=' + paramValue;
                else
                    url += '&' + paramName + '=' + paramValue;
            }
            return url;
        },
        removeParam: function(url_string, variable_name) {
            var URL = String(url_string);
            var regex = new RegExp('\\?' + variable_name + '=[^&]*&?', 'gi');
            URL = URL.replace(regex, '?');
            regex = new RegExp('\\&' + variable_name + '=[^&]*&?', 'gi');
            URL = URL.replace(regex, '&');
            URL = URL.replace(/(\?|&)$/, '');
            regex = null;
            return URL;
        },
        getTitle: function(model, noEncode) {
            if (!gon.display_options.showCaptions) return '';
            if (!_.isFalsy(model.attributes.title)) {
                return model.attributes.title;
            }
            if (!_.isFalsy(model.attributes.album_title)) {
                return model.attributes.album_title;
            }
            if (!_.isFalsy(model.attributes.photo_title)) {
                return model.attributes.photo_title;
            }
            return false;
        },
        handleLike: function(CURRENTPHOTOID, link, service, post_id) {
            clearTimeout(this.shareTimer);
            this.shareTimer = setTimeout(function() {
                var post;
                if (typeof post_id != 'undefined') post = post_id;
                else post = null;
                if (parseInt(CURRENTPHOTOID) > 0) {
                    $.ajax({
                        url: '/social/share',
                        type: 'post',
                        data: {
                            'album_photo_id': parseInt(CURRENTPHOTOID),
                            'fingerprint': gon.fingerprint,
                            'link': link,
                            'provider': service,
                            'post_id': post
                        },
                        dataType: 'json',
                        success: function(response) {
                            if (response.error_code != 0) {
                                //console.log('Error logging like');
                            }
                        }
                    });
                }
            }, 2000);
        },
        handlePinterestShare: function(model) {
            var title = this.getTitle(model);
            var shareLink = this.insertParam(this.url, 'pixlee_album_photo_id', model.get('album_photo_id'));
            if (_.isFalsy(title)) {
                if (gon.current_album.campaign) {
                    title = 'I just voted for my favorite photo!';
                } else {
                    title = 'Check this photo out!';
                }
                window.open('https://pinterest.com/pin/create/button/?url=' + App.request('encode:utf8', shareLink) + '&media=' + App.request('encode:utf8', App.request('get:photo:tumbnail', model)) + '&description=' + App.request('encode:utf8', title), '_blank', 'height=450,width=600,toolbar=0,resizable=0');
            } else {
                title = App.request('decode:utf8', title);
                window.open('https://pinterest.com/pin/create/button/?url=' + App.request('encode:utf8', shareLink) + '&media=' + App.request('encode:utf8', App.request('get:photo:tumbnail', model)) + '&description=' + App.request('encode:utf8', title), '_blank', 'height=450,width=600,toolbar=0,resizable=0');
            }
            this.handleLike(model.get('album_photo_id'), shareLink, 'pinterest');
        },
        handleTwitterShare: function(model) {
            var title = this.getTitle(model);
            var shareLink = this.insertParam(this.url, 'pixlee_album_photo_id', model.get('album_photo_id'));
            if (_.isFalsy(title)) {
                if (gon.current_album.campaign) {
                    title = 'I just voted for my favorite photo! Vote for your fave: ';
                } else {
                    title = 'Check this photo out! ';
                }
                window.open('https://twitter.com/intent/tweet?text=' + App.request('encode:utf8', title) + ' ' + '&url=' + App.request('encode:utf8', shareLink), '_blank', 'height=450,width=600,toolbar=0,resizable=0');
            } else {
                title = App.request('decode:utf8', title);
                window.open('https://twitter.com/intent/tweet?text=' + App.request('encode:utf8', title) + ' ' + '&url=' + App.request('encode:utf8', shareLink), '_blank', 'height=450,width=600,toolbar=0,resizable=0');
            }
            this.handleLike(model.get('album_photo_id'), shareLink, 'twitter');
        },
        handleFacebookShare: function(model) {
            var _this = this;
            var title = this.getTitle(model);
            var shareLink = this.insertParam(this.url, 'pixlee_album_photo_id', model.get('album_photo_id'));
            if (gon.FB_APP_ID && !this.reinitedFB) {
                FB.init({
                    appId: gon.FB_APP_ID,
                    channelUrl: gon.global.pixleePhotosServer + "channel.html",
                    status: true,
                    cookie: true,
                    xfbml: true
                });
                this.reinitedFB = true;
            }
            if (_.isFalsy(title)) {
                if (gon.current_album.campaign) {
                    title = 'I just voted for my favorite photo!';
                } else {
                    title = 'Check this photo out!';
                }
            }
            var picture;
            if (model.get('source') == 'facebook' && model.get('content_type') == 'video') {
                picture = null;
            } else {
                picture = App.request('get:photo:tumbnail', model);
            }
            var obj = {
                method: 'stream.publish',
                link: shareLink,
                picture: picture,
                name: App.request('decode:utf8', gon.current_album.title),
                description: App.request('decode:utf8', title),
                display: 'popup'
            };

            function callback(response) {
                if (response && response.post_id) {
                    _this.handleLike(model.get('album_photo_id'), shareLink, 'facebook', response.post_id);
                }
                //reportSocialInteraction('facebook');
            }
            FB.ui(obj, callback);
        },
        handleTumblrShare: function(model) {
            var title = this.getTitle(model);
            var shareLink = this.insertParam(this.url, 'pixlee_album_photo_id', model.get('album_photo_id'));
            if (_.isFalsy(title)) {
                if (gon.current_album.campaign) {
                    title = 'I just voted for my favorite photo!';
                } else {
                    title = 'Check this photo out!';
                }
                window.open('https://www.tumblr.com/share/photo?clickthru=' + App.request('encode:utf8', shareLink) + '&source=' + App.request('encode:utf8', App.request('get:photo:tumbnail', model)) + '&caption=' + App.request('encode:utf8', title), '_blank', 'height=450,width=600,toolbar=0,resizable=0');
            } else {
                title = App.request('decode:utf8', title);
                window.open('https://www.tumblr.com/share/photo?clickthru=' + App.request('encode:utf8', shareLink) + '&source=' + App.request('encode:utf8', App.request('get:photo:tumbnail', model)) + '&caption=' + App.request('encode:utf8', title), '_blank', 'height=450,width=600,toolbar=0,resizable=0');
            }
            this.handleLike(model.get('album_photo_id'), shareLink, 'tumblr');
        },
        loadMoreClicked: function(photos) {
            this.logger.loadMore(gon.widget, photos);
        },
        actionClicked: function(model, action_link_url, action_text) {
            this.logger.actionClicked(gon.widget, model.get('album_photo_id'), action_link_url, action_text);
        },
        actionLinkLoaded: function(photo, links) {
            this.logger.actionLinkLoaded(gon.widget, photo, links);
        },
        logNavRight: function(photos) {
            this.postMessage({
                msg: 'navRight'
            });
            this.logger.navRight(gon.widget, photos);
        },
        logNavLeft: function(photos) {
            this.postMessage({
                msg: 'navLeft'
            });
            this.logger.navLeft(gon.widget, photos);
        },
        logger: {
            types: {
                'photowall': {
                    widget: 'Photowall',
                    action: 'Opened Photowall'
                },
                'horizontal': {
                    widget: 'Horizontal',
                    action: 'Opened Horizontal'
                }
            },
            getDistinctUserHash: function() {
                if (typeof analytics !== 'undefined' && analytics.getAnonymousId) {
                    return analytics.getAnonymousId();
                }
            },
            getTime: function() {
                return Date.now();
            },
            trackObj: function(type) {
                return this.types[type];
            },
            convertToStrings: function(photos) {
                photos = _.map(photos, function(photo) {
                    return photo + '';
                });
                return photos.join(',');
            },
            openWidget: function(key, time, photos) {
                if (this.widgetInitiated) return false;
                else this.widgetInitiated = true;
                var _this = this;
                var type = this.trackObj(key);
                var _time = time - gon.widgetInitTime;
                _this.first_photos = photos;
                //console.log('widget opened:' + type.widget);
                if (typeof analytics != 'undefined') {
                    API.trackAnalytics('Opened Widget', {
                        album_id: gon.current_album.id,
                        account_id: gon.current_account.id,
                        widget: type.widget,
                        parentURL: gon.parentURL,
                        publication_id: gon.recipe.filter_sort_id || gon.publication_id,
                        screenWidth: gon.availWidth,
                        distinct_user_hash: _this.getDistinctUserHash(),
                        screenHeight: gon.availHeight,
                        widgetOffset: gon.offsetY,
                        photos: _this.convertToStrings(photos),
                        documentHeight: gon.docHeight,
                        load_time: _time,
                        sortType: gon.sortType,
                        pixlee_init: gon.pixlee_init,
                        pixlee_ready: gon.pixlee_ready,
                        pixlee_all_done: gon.pixlee_all_done,
                        displayed: gon.widgetDisplay,
                        embed_type: 'embed',
                        fingerprint: gon.fingerprint
                    });
                }

            },
            openPhoto: function(key, album_photo_id) {
                var _this = this;
                var type = this.trackObj(key);
                //console.log("opened: " + album_photo_id);
                if (typeof analytics != 'undefined') {
                    API.trackAnalytics('Interacted', {
                        subcollection: 'Opened Lightbox',
                        album_id: gon.current_album.id,
                        distinct_user_hash: _this.getDistinctUserHash(),
                        account_id: gon.current_account.id,
                        album_photo_id: album_photo_id,
                        publication_id: gon.recipe.filter_sort_id || gon.publication_id,
                        widget: type.widget,
                        sortType: gon.sortType,
                        embed_type: 'embed',
                        parentURL: gon.parentURL,
                        fingerprint: gon.fingerprint
                    });
                }
            },
            actionLinkLoaded: function(key, album_photo_id, links) {
                var _this = this;
                var type = this.trackObj(key);
                //console.log("opened: " + album_photo_id);
                if (typeof analytics != 'undefined') {
                    API.trackAnalytics('Action Link Loaded', {
                        album_id: gon.current_album.id,
                        distinct_user_hash: _this.getDistinctUserHash(),
                        account_id: gon.current_account.id,
                        album_photo_id: album_photo_id,
                        publication_id: gon.recipe.filter_sort_id || gon.publication_id,
                        widget: type.widget,
                        sortType: gon.sortType,
                        embed_type: 'embed',
                        links: !_.isFalsy(links) ? links : 1,
                        rich_action: gon.display_options.rich_action_active,
                        parentURL: gon.parentURL,
                        fingerprint: gon.fingerprint
                    });
                }
            },
            leaveLightbox: function(key) {
                var _this = this;
                var type = this.trackObj(key);

            },
            actionClicked: function(key, album_photo_id, action_link_url, action_text) {
                var _this = this;
                var type = this.trackObj(key);
                //console.log('load more:' + type.widget);
                if (typeof analytics != 'undefined') {
                    API.trackAnalytics('Interacted', {
                        subcollection: 'Action Clicked',
                        album_id: gon.current_album.id,
                        account_id: gon.current_account.id,
                        distinct_user_hash: _this.getDistinctUserHash(),
                        publication_id: gon.recipe.filter_sort_id || gon.publication_id,
                        widget: type.widget,
                        album_photo_id: album_photo_id,
                        embed_type: 'embed',
                        sortType: gon.sortType,
                        action_text: action_text,
                        rich_action: gon.display_options.rich_action_active,
                        action_link_url: action_link_url,
                        parentURL: gon.parentURL,
                        fingerprint: gon.fingerprint
                    });
                }
            },
            loadMore: function(key, photos) {
                var _this = this;
                var type = this.trackObj(key);
                //console.log('load more:' + type.widget);
                if (typeof analytics != 'undefined') {
                    API.trackAnalytics('Interacted', {
                        subcollection: 'Load More',
                        album_id: gon.current_album.id,
                        account_id: gon.current_account.id,
                        distinct_user_hash: _this.getDistinctUserHash(),
                        publication_id: gon.recipe.filter_sort_id || gon.publication_id,
                        widget: type.widget,
                        embed_type: 'embed',
                        sortType: gon.sortType,
                        photos: _this.convertToStrings(photos),
                        parentURL: gon.parentURL,
                        fingerprint: gon.fingerprint
                    });
                }

            },
            navRight: function(key, photos) {
                var _this = this;
                var type = this.trackObj(key);
                if (typeof analytics != 'undefined') {
                    API.trackAnalytics('Interacted', {
                        subcollection: 'Nav Right',
                        album_id: gon.current_album.id,
                        distinct_user_hash: _this.getDistinctUserHash(),
                        account_id: gon.current_account.id,
                        publication_id: gon.recipe.filter_sort_id || gon.publication_id,
                        widget: type.widget,
                        embed_type: 'embed',
                        photos: _this.convertToStrings(photos),
                        parentURL: gon.parentURL,
                        fingerprint: gon.fingerprint
                    });
                }
            },
            navLeft: function(key, photos) {
                var _this = this;
                var type = this.trackObj(key);
            }
        },
        testActions: {
            init: function() {
                var obj = JSON.stringify({
                    msg: 'run',
                    len: $('.photo-item-container').length
                });
                socket.postMessage(obj);
            },
            click: function(ind) {
                $('.photo-item-container').eq(ind).find('.lightboxed').first().click();
                var timer = setTimeout(function() {
                    if (ind % 2 == 0) {
                        $('#fancybox-close').click();
                    } else {
                        $('#fancybox-overlay').click();
                    }
                    $('#fancybox-close').click();
                    var obj = JSON.stringify({
                        msg: 'iterate'
                    });
                    socket.postMessage(obj);
                }, 2000);
                var imgLoad = new imagesLoaded('#fancybox-content');
                imgLoad.on('always', function(instance) {
                    timer();
                });
            },
            navigate: function() {
                var y = function() {
                    setTimeout(function() {
                        if ($('#fancybox-left').css('display') !== 'none') {
                            $('#fancybox-left').click();
                            var imgLoad = new imagesLoaded('#fancybox-content');
                            imgLoad.on('always', function(instance) {
                                y();
                            });
                        } else {
                            $('#fancybox-close').click();
                            var obj = JSON.stringify({
                                msg: 'doneNavigating'
                            });
                            socket.postMessage(obj);
                        }
                    }, 1000);
                };

                var t = function() {
                    setTimeout(function() {
                        if ($('#fancybox-right').css('display') !== 'none') {
                            $('#fancybox-right').click();
                            var imgLoad = new imagesLoaded('#fancybox-content');
                            imgLoad.on('always', function(instance) {
                                t();
                            });
                        } else {
                            y();
                        }
                    }, 1000);
                };
                $('.photo-item-container').eq(0).find('.lightboxed').first().click();
                t();
            },
            paginate: function() {
                var y = function() {
                    setTimeout(function() {
                        if ($('#left-nav-arrow').css('display') !== 'none') {
                            $('#left-nav-arrow').click();
                            y();
                        } else {
                            var obj = JSON.stringify({
                                msg: 'donePaginating'
                            });
                            socket.postMessage(obj);
                        }
                    }, 2000);
                };

                var t = function() {
                    setTimeout(function() {
                        if ($('#right-nav-arrow').css('display') !== 'none') {
                            $('#right-nav-arrow').click();
                            t();
                        } else {
                            y();
                        }
                    }, 2000);
                };
                t();
            },
            loadMore: function() {
                $('#load_more').click();
                var _this = this;
                $('#container').masonry('off', 'layoutComplete');
                $('#container').masonry('on', 'layoutComplete', function() {
                    _this.postMessage({
                        msg: 'render',
                        height: $('body').height()
                    });
                    clearTimeout(_this.t);
                    _this.t = setTimeout(function() {
                        var obj = JSON.stringify({
                            msg: 'scroll'
                        });
                        socket.postMessage(obj);
                        _this.t = null;
                    }, 2000);
                });
            }
        }
    };

    App.vent.on('show:photowall:item', function(photo, album) {
        App.navigate(Routes.photowall_item_path(album.id), {
            trigger: false
        });
        API.photowallItem(photo, album);
    });

    App.vent.on('show:horizontal:item', function(photo, album) {
        App.navigate(Routes.horizontal_path(album.id), {
            trigger: false
        });
        API.horizontalItem(photo, album);
    });

    App.vent.on('post:message:iframe', function(msg) {
        API.postMessage(msg);
    });

    App.commands.setHandler('lightbox:init', function(collection) {
        API.initFancyBox(collection);
    });

    App.commands.setHandler('changed:photo', function(wrapper, photo) {
        API.triggerChangePhoto(wrapper, photo);
    });

    App.commands.setHandler('is:video', function(container, video, selectedArray, selectedIndex) {
        API.isVideo(container, video, selectedArray, selectedIndex);
    });

    App.commands.setHandler('resize:window', function(container, video) {
        API.itemOpen();
    });

    App.commands.setHandler('check:window', function(container, video) {
        API.checkWindow();
    });

    //share
    App.commands.setHandler('open:share:pinterest', function(model) {
        API.handlePinterestShare(model);
    });

    App.commands.setHandler('open:share:twitter', function(model) {
        API.handleTwitterShare(model);
    });

    App.commands.setHandler('open:share:facebook', function(model) {
        API.handleFacebookShare(model);
    });

    App.commands.setHandler('open:share:tumblr', function(model) {
        API.handleTumblrShare(model);
    });

    App.commands.setHandler('load:more', function(photos) {
        API.loadMoreClicked(photos);
    });

    App.commands.setHandler('exec:vote:clicked', function(view, model) {
        API.voteClicked(view, model);
    });

    App.commands.setHandler('log:action:clicked', function(model, action_link_url, action_text) {
        API.actionClicked(model, action_link_url, action_text);
    });
    App.commands.setHandler("action:link:loaded", function(photo, links) {
        API.actionLinkLoaded(photo, links);
    });
    App.commands.setHandler('nav:left', function(model) {
        API.logNavLeft(model);
    });

    App.commands.setHandler('nav:right', function(photos) {
        API.logNavRight(photos);
    });


    App.commands.setHandler("widget:loaded", function(time, photos) {
        API.widgetLoaded(time, photos);
    });

    App.commands.setHandler("init:infinite:scroll", function() {
        API.initInfiniteScroll();
    });

    App.commands.setHandler("load:more:lightbox", function() {
        API.loadMoreLightBox();
    });

    App.commands.setHandler("load:photo:packery", function(photo) {
        API.loadPhoto(Routes.backbone.photowall_path, photo);
    });

    App.commands.setHandler("analytics:track:event", function(ev, props) {
        API.trackAnalytics(ev, props);
    });

    WidgetsApp.on("start", function() {
        new WidgetsApp.Router({
            controller: API
        });
        API.initSocket('ok');
    });


});
